$(document).ready(function () {
    $('.recommended-articles.module').each(function () {
        var $section = $(this);
        var $grid = $section.find('.article-card-grid');
        var $moreBtn = $section.find('.recommended-articles__button-more');
        var $lessBtn = $section.find('.recommended-articles__button-less');

        var animationDuration = 400; //match duration in CSS
        function easeInOutQuad(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }

        function getTargetLessHeight() {
            var $clone = $grid.clone()
                .css({
                    'position': 'absolute',
                    'visibility': 'hidden',
                    'display': 'grid',
                    'max-height': 'none'
                })
                .removeClass('article-card-grid--show-all article-card-grid--show-less')
                .addClass('article-card-grid--show-less');

            $clone.appendTo($section);
            var height = $clone.outerHeight();
            $clone.remove();
            return height;
        }

        if ($grid.hasClass('article-card-grid--show-less')) {
            var initialLessHeight = getTargetLessHeight();
            $grid.css('max-height', initialLessHeight + 'px');
            $lessBtn.hide();
            $moreBtn.show();
        } else if ($grid.hasClass('article-card-grid--show-all')) {
            $grid.css('max-height', 'none'); //fully expand
            if ($moreBtn.length && $lessBtn.length) {
                $moreBtn.hide();
                $lessBtn.show();
            }
        }

        $moreBtn.on('click', function () {
            $grid.removeClass('article-card-grid--show-less').addClass('article-card-grid--show-all');
            $grid.css('max-height', 'none'); //fully expand

            $moreBtn.hide();
            $lessBtn.show();
        });

        var scrollAnimationId = null;

        $lessBtn.on('click', function () {
            if (scrollAnimationId) {
                cancelAnimationFrame(scrollAnimationId);
                scrollAnimationId = null;
            }

            var heightBefore = $grid.outerHeight();
            var targetLessHeight = getTargetLessHeight();
            var totalHeightChange = heightBefore - targetLessHeight;

            $grid.css('max-height', heightBefore + 'px');
            $grid.width();

            $grid.css('max-height', targetLessHeight + 'px');

            $lessBtn.hide();
            $moreBtn.show();

            var startTime = performance.now();
            var startScrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var scrollChangeAmount = -totalHeightChange;

            function animateScroll(currentTime) {
                var elapsedTime = currentTime - startTime;
                var progress = Math.min(elapsedTime / animationDuration, 1);
                var easedProgress = easeInOutQuad(progress);

                var newScrollTop = startScrollTop + (scrollChangeAmount * easedProgress);
                window.scrollTo(0, newScrollTop);

                if (progress < 1) {
                    scrollAnimationId = requestAnimationFrame(animateScroll);
                } else {
                    scrollAnimationId = null;
                }
            }
            scrollAnimationId = requestAnimationFrame(animateScroll);

            var transitionEndFired = false;
            $grid.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
                if (transitionEndFired) return;
                transitionEndFired = true;

                if (scrollAnimationId) {
                    cancelAnimationFrame(scrollAnimationId);
                    scrollAnimationId = null;
                    window.scrollTo(0, startScrollTop + scrollChangeAmount); //snap to final scroll position
                }
                $grid.removeClass('article-card-grid--show-all').addClass('article-card-grid--show-less');
            });
        });
    });
});
